import { FormApi } from 'final-form'
import { get, List, PropertyName, zipObject } from 'lodash'
import React, { ReactElement, ReactNode, useState } from 'react'
import { Form as FinalForm } from 'react-final-form'

import {
  BaseFullTextFilter,
  FullTextFilterFormProps,
  IField,
  TFApplyFilter,
  TFilterForm,
} from '../types'
import Form from './Form'
import { stringifyValues } from './Form'

interface FullTextFilterProps
  extends BaseFullTextFilter,
    FullTextFilterFormProps {
  applyFilter: TFApplyFilter
  filterForm: TFilterForm
  customFilterBarElement?: ReactNode
}

const FullTextFilter = (props: FullTextFilterProps): React.ReactElement => {
  const {
    filters,
    setFilter,
    applyFilter,
    initialValues,
    applyColor = 'primary',
    setDetailFilterOpen,
    detailFilterOpen,
    isMobile,
    hideDetail,
    fallBackDeleteFilter,
    useLocalStateFiltering,
    applyLocalFilter,
    customFilterBarElement,
  } = props

  const [form, setForm] = useState<FormApi>()

  const submit = (data: any): void => {
    const stringifyedData = stringifyValues(data)
  }

  const apply = (reset: boolean, isFulltextSearch: boolean): void => {
    if (useLocalStateFiltering) {
      applyLocalFilter({ reset: reset, onlyFts: false })
    } else {
      applyFilter({
        reset: {
          reset: reset,
          onlyFts: false,
          isFulltextSearch,
        },
      })
    }
  }

  return (
    <FinalForm
      onSubmit={submit}
      subscription={{ submitting: true, pristine: true }}
    >
      {(formProps) => (
        <Form
          {...formProps}
          getFormApi={setForm}
          initialValues={{
            ...initialValues,
            ...zipObject(
              get(props.filterForm, 'filter', []).map(
                (f: IField) => f.field,
              ) as List<PropertyName>,
              get(props.filterForm, 'filter', []).map(
                (f: IField) => f.value,
              ) as List<PropertyName>,
            ),
          }}
          filters={filters}
          setFilter={setFilter}
          apply={apply}
          applyColor={applyColor}
          setDetailFilterOpen={setDetailFilterOpen}
          detailFilterOpen={detailFilterOpen}
          isMobile={isMobile}
          hideDetail={hideDetail}
          fallBackDeleteFilter={fallBackDeleteFilter}
          useLocalStateFiltering={useLocalStateFiltering}
          applyLocalFilter={applyLocalFilter}
          fulltextSearchLoading={props.fulltextSearchLoading}
          customFilterBarElement={customFilterBarElement}
        />
      )}
    </FinalForm>
  )
}

export default FullTextFilter
